module.exports = __webpack_public_path__ + "img/intellisoft-logo-24x13.4ccd0ffb.png";